import { Action } from '@ngrx/store';

import { ApiFragment } from '@stylehaven/components';

export enum RecordsActionTypes {
    AddRecords = '[RecordsState] Add records',
    AddRecord = '[RecordsState] Add record',
    RecordsLoading = '[RecordsLoading] Set records loading',
    RecordsError = '[RecordsError] Set records error'
}

export class AddRecords implements Action {
    type: RecordsActionTypes.AddRecords = RecordsActionTypes.AddRecords;
    constructor(public records: ApiFragment[]) {}
}

export class AddRecord implements Action {
    type: RecordsActionTypes.AddRecord = RecordsActionTypes.AddRecord;
    constructor(public record: ApiFragment) {}
}

export class SetRecordsLoading implements Action {
    type: RecordsActionTypes.RecordsLoading = RecordsActionTypes.RecordsLoading;
    constructor(public loading: boolean) {}
}

export class SetRecordsError implements Action {
    type: RecordsActionTypes.RecordsError = RecordsActionTypes.RecordsError;
    constructor(public error: boolean) {}
}

export type RecordsAction = AddRecords | AddRecord | SetRecordsLoading | SetRecordsError;
